import Button from '@shared/components/core/button/CoreButton';
import LicenseUpgradeDialog from '@shared/components/organization/invite/MaxSeatsDialog';
import useCurrentOrgDetailsFetching from '@shared/hooks/useCurrentOrgDetailsFetching';
import OrganizationMemberRole from '@shared/models/organizations/OrganizationMemberRole';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import InviteCreateDialog from './InviteCreateDialog';

interface IInviteCreateAccessProps {
    myRole: OrganizationMemberRole;
    organizationId: string;
}

export default function InviteCreateAccess({ myRole, organizationId }: Readonly<IInviteCreateAccessProps>) {
    const { t } = useTranslation();
    const [openDialog, setOpenDialog] = useState<boolean>(false);
    const handleOpenDialog = () => setOpenDialog(true);
    const handleCloseDialog = () => setOpenDialog(false);
    const { remainingSeats } = useCurrentOrgDetailsFetching();

    if (!myRole || !organizationId) return null;
    if (!myRole.canInviteMembers && !myRole.isAdmin) return null;

    return (
        <>
            <Button $color="secondary" onClick={handleOpenDialog} startIcon="plus">
                {t('common:organization.invite.edit')}
            </Button>
            {remainingSeats > 0 ? (
                <InviteCreateDialog
                    open={openDialog}
                    onClose={handleCloseDialog}
                    organizationId={organizationId}
                    myRole={myRole}
                />
            ) : (
                <LicenseUpgradeDialog
                    open={openDialog}
                    onClose={handleCloseDialog}
                    orgId={organizationId}
                    canManageBilling={myRole?.canManageBilling || myRole?.isAdmin}
                />
            )}
        </>
    );
}
